// extracted by mini-css-extract-plugin
export default {"faqSearch":"obXk8j8IiI","faqSearchContainer":"HKbm7n6iPQ","faqSearchContent":"c8LsuJgw0Y","faqSearchForm":"hhwjQU3aqH"};